import axios from './Api';

export function GetPartner(data: Partner.IGetPartnerParams) {
  return axios.post<Partner.IPartner[]>('/partners/search', data);
}

export function ExportPartner(data = {}) {
  return axios.post<Partner.IExportPartner>('/partners/export', data);
}

export function GetExportStatus() {
  return axios.get<Partner.IExportPartner[]>('/partners/export/status');
}

export function GetExportCount() {
  return axios.get<Partner.IPartnerExportCount>('/partners/export/count');
}

export function CancelExport(id: string | number = '') {
  return axios.get<Axios.IResponseSuccess>(`/partners/export/${id}/cancel`);
}

export function GerExportFile(id: string | number = '') {
  return axios.get<Partner.IPartnerExportFile>(`/partners/export/${id}/download`, { responseType: 'blob' });
}
